export class DatePickerLocale {

  static it: any = {
    firstDayOfWeek: 0,
    dayNames: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],
    dayNamesShort: ["Dom", "Lun", "Mar", "Mer", "Gio", "Ven", "Sab"],
    dayNamesMin: ["D", "L", "M", "M", "G", "V", "S"],
    monthNames: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
    monthNamesShort: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
    startsWith: "Inizia con",
    contains: "Contiene",
    notContains: "Non contiene",
    endsWith: "Finisce con",
    equals: "Uguale",
    notEquals: "Diverso",
    noFilter: "Senza filtri",
    lt: "Minore di",
    lte: "Minore o uguale di",
    gt: "Maggiore di",
    gte: "Maggiore o uguale di",
    is: "E'",
    isNot: "Non è",
    before: "Prima",
    after: "Dopo",
    clear: "Pulisci",
    apply: "Applica",
    matchAll: "Abbina tutto",
    matchAny: "Corrisponde a qualsiasi",
    addRule: "Aggiungi regola",
    removeRule: "Rimuovi regola",
    accept: "Si",
    reject: "No",
    choose: "Scegli",
    upload: "Upload",
    cancel: "Annulla",
    today: "Oggi",
    weekHeader: "Stm"
  };

  static en: any = {
    firstDayOfWeek: 0,
    dayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
    dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
    monthNamesShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    startsWith: "Starts with",
    contains: "Contains",
    notContains: "Not contains",
    endsWith: "Ends with",
    equals: "Equals",
    notEquals: "Not equals",
    noFilter: "No Filter",
    lt: "Less than",
    lte: "Less than or equal to",
    gt: "Greater than",
    gte: "Great then or equals",
    is: "Is",
    isNot: "Is not",
    before: "Before",
    after: "After",
    clear: "Clear",
    apply: "Apply",
    matchAll: "Match All",
    matchAny: "Match Any",
    addRule: "Add Rule",
    removeRule: "Remove Rule",
    accept: "Yes",
    reject: "No",
    choose: "Choose",
    upload: "Upload",
    cancel: "Cancel",
    today: "Today",
    weekHeader: "Wk"
  };
}
